(function(){
  /******VIDEO REVIEWS SLIDER*******/

  const videoReviewSlider = new Swiper(".video--review--slider",{
    spaceBetween: 10,
    breakpoints: {
      320: {
        slidesPerView: 2.25
      },
      480: {
        slidesPerView: 2
      },
      750: {
        slidesPerView: 3
      },
      1024: {
        slidesPerView: 4
      }
    }
  })


  /******VIDEO PLAYING FUNCTIONALITY*****/

  const playTrigger = document.querySelectorAll("[playTrigger]");
  if(playTrigger.length > 0){
    playTrigger.forEach(function(e){
      e.addEventListener("click",function(){
        this.closest("[videoWrapper]").querySelector("video").play();
        this.classList.add("hidden");
      })
    })
  }

  const videoTriggers = document.querySelectorAll("[videoWrapper] video");
  if(videoTriggers.length > 0){
    videoTriggers.forEach(function(e){
      e.addEventListener("click",function(){
        if(!this.paused || !this.ended){
          this.pause();
          this.closest("[videoWrapper]").querySelector("[playTrigger]").classList.remove("hidden");
        }
      })
      e.addEventListener("ended",function(){
          this.closest("[videoWrapper]").querySelector("[playTrigger]").classList.remove("hidden");
          this.load();
      })
    })
  }
})();